import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import DropSection from './components/DropSection';
import Lookbook from './components/Lookbook';
import FitGuide from './components/FitGuide';
import Reviews from './components/Reviews';
import InfoSection from './components/InfoSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen bg-black text-white selection:bg-[#D4FF00] selection:text-black">
      <Navbar />
      <main>
        <Hero />
        <DropSection />
        <Lookbook />
        <FitGuide />
        <Reviews />
        <InfoSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;